//Built-In
import React, {Fragment} from 'react';

//External
//Internal
export default class ButtonComponent extends React.Component{
    constructor(props) {
        super(props);
    }

    render(){
        let component = this.props.component;
        let buttons = component['buttons'];
        return (
            <Fragment>
                <div>
                    <label className={'group-header-lbl'}>Buttons</label>
                    <div className={'button-content'}>
                        <ol>
                        {
                            buttons.map((button, index)=>{
                                let btnType = button['type'];
                                let btnText = button['text'];
                                return (
                                    <li>
                                        {btnText}
                                    </li>
                                )
                            })
                        }
                        </ol>
                    </div>
                </div>
            </Fragment>
        )
    }
}
